import { render, staticRenderFns } from "./WsDownloadButton001.vue?vue&type=template&id=263770df&scoped=true"
import script from "./WsDownloadButton001.vue?vue&type=script&lang=js"
export * from "./WsDownloadButton001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263770df",
  null
  
)

export default component.exports